const generateCustomerHash = (string: string) => {
  return Math.abs(
    string.split('').reduce((a, b) => {
      a = (a << 5) - a + b.charCodeAt(0);
      return a & a;
    }, 0)
  );
};

export { generateCustomerHash };
